<template>
  <div>
    <h5 class="header-stripe">
      <span>{{$t('INDENT_REJECT')}}</span>
      <div class="action">
        <Button type="secondary" size="mini" @click="cancel">{{$t('INDENT_CANCEL')}}</Button>
        <Button type="primary" size="mini" :disabled="disableReject"
          @click="reject">{{$t('INDENT_REJECT')}}</Button>
      </div>
    </h5>
    <div class="py-15">
      <Form  class="form-default mr-5">
        <div>
          <RadioGroup v-model="indentRejectReason.data" display="block">
            <Radio v-for="radioButton in indentRejectOptions"
              :key="radioButton.key"
              v-model="indentRejectReason.data"
              @change="indentRejectReason.custom.reason =''"
              :label="radioButton.value">
              {{radioButton.value}}
            </Radio>
          </RadioGroup>
        </div>
          <div v-if="indentRejectReason.data === $t('OTHERS')">
            <FormItem :label="$t('OTHERS')" :required="true">
              <Input :placeholder="$t('INDENT_ENTER_REJECTION_REASON')"
                :maxlength="150"
                :rows="2"
                type="textarea"
                class="form-control" v-model="indentRejectReason.custom.reason" />
            </FormItem>
          </div>
          <div v-if="isFreightRateAndUnitRequired">
            <Row>
              <Col :span="24">
                <FormItem :label="$t('INDENT_FREIGHT_RATE')" :required="isFreightRateAndUnitRequired">
                  <Input :placeholder="$t('INDENT_ENTER_FREIGHT_RATE')"
                    v-model="indentRejectReason.custom.freightRate"
                    type="number"
                    class="form-control" />

                </FormItem>
              </Col>
              <Col :span="24">
                <FormItem :label="$t('INDENT_FREIGHT_UNIT')" :required="isFreightRateAndUnitRequired">
                  <Select
                    v-model="indentRejectReason.custom.freightUnit"
                    :placeholder="$t('INDENT_SELECT_FREIGHT_UNIT')"
                    class="select-default select-header"
                    >
                    <Option
                      v-for="item in contractTypes"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id" />
                  </Select>
                </FormItem>
              </Col>
            </Row>
          </div>
      </Form>
    </div>
  </div>
</template>
<script>
import { contractTypes, indentRejectOptions } from '@/constants/indentConstants';
import { movementType } from 'pando-constants';

export default {
  props: {
    indent: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      indentRejectReason: {
        custom: {
          reason: '',
          freightRate: (this.indent && this.indent.base_freight && this.indent.base_freight.freight_charge) || 0,
          freightUnit: (this.indent && this.indent.base_freight && this.indent.base_freight.freight_unit) || 1,
        },
        data: '',
      },
      indentRejectOptions,
      contractTypes,
    };
  },
  computed: {
    disableReject() {
      let flag = false;
      const selectedReason = this.indentRejectReason && this.indentRejectReason.data;
      if (selectedReason.length === 0 && this.indentRejectReason.custom.reason.length === 0) {
        flag = true;
      }
      if (selectedReason === 'Existing rates are not competitive' &&
        this.$hasFeature('override_freight_while_indent_reject')) {
          flag = !(this.indentRejectReason.custom.freightRate && this.indentRejectReason.custom.freightUnit);
      }
      return flag;
    },
    isFreightRateAndUnitRequired() {
      return this.indentRejectReason && this.indentRejectReason.data === 'Existing rates are not competitive' &&
        this.$hasFeature('override_freight_while_indent_reject') &&
        !this.$hasFeature('ptl_grouping');
    },
  },
  async created() {
    await this.getReasonSettings();
  },
  methods: {
    reject() {
      const comments = this.indentRejectReason.data === 'Others' ?
        this.indentRejectReason.custom.reason :
        this.indentRejectReason.data;
      let payload = { comments };
      if (this.isFreightRateAndUnitRequired) {
        payload = {
          ...payload,
          ...(this.isFreightRateAndUnitRequired) ?
            {
              freight_rate: this.indentRejectReason.custom.freightRate,
              freight_unit: this.indentRejectReason.custom.freightUnit.toString() } :
            {},
        };
      }
      this.$emit('rejectIndent', payload);
      this.indentRejectReason = {
        custom: {
          reason: '',
        },
        data: '',
      };
    },
    cancel() {
      this.$emit('cancelAction');
      this.indentRejectReason = {
        custom: {
          reason: '',
        },
        data: '',
      };
    },
    async getReasonSettings() {
      let depotId;
      if (this.indent && [movementType.PRIMARY, movementType.SECONDARY].includes(this.indent.movement)) { // TODO: Use constants
        depotId = this.indent.sources && this.indent.sources[0]
          && this.indent.sources[0].location_id;
      } else {
        depotId = this.indent.destinations && this.indent.destinations[0]
          && this.indent.destinations[0].location_id;
      }
      const payload = {
        type: 'INDENT_REJECTION',
        movement: this.indent && this.indent.movement,
        depot_id: depotId,
      };
      const result = await this.$store.dispatch('indents/getReasonSettings', payload);
      if (result && result.data && result.data.length) {
        const configReasons = result.data.map(item => ({
          key: item,
          value: item,
        }));
        this.indentRejectOptions = [
          ...this.indentRejectOptions,
          ...configReasons,
          {
            value: 'Others',
            key: 'OTHERS',
          },
        ];
      } else {
        this.indentRejectOptions = [
          ...this.indentRejectOptions,
          {
            value: 'Others',
            key: 'OTHERS',
          },
        ];
      }
    },
  },
};
</script>
